/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminPalletOrderAttachments,
    AdminPalletOrderAttachmentsFromJSON,
    AdminPalletOrderAttachmentsFromJSONTyped,
    AdminPalletOrderAttachmentsToJSON,
} from './AdminPalletOrderAttachments';

/**
 * 
 * @export
 * @interface AdminPalletOrder
 */
export interface AdminPalletOrder {
    /**
     * 
     * @type {Array<AdminPalletOrderAttachments>}
     * @memberof AdminPalletOrder
     */
    attachments?: Array<AdminPalletOrderAttachments>;
    /**
     * 
     * @type {number}
     * @memberof AdminPalletOrder
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPalletOrder
     */
    items: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPalletOrder
     */
    junkItems?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminPalletOrder
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPalletOrder
     */
    orderDate: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPalletOrder
     */
    orderLink: string;
    /**
     * 
     * @type {number}
     * @memberof AdminPalletOrder
     */
    price: number;
}

export function AdminPalletOrderFromJSON(json: any): AdminPalletOrder {
    return AdminPalletOrderFromJSONTyped(json, false);
}

export function AdminPalletOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPalletOrder {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attachments': !exists(json, 'attachments') ? undefined : ((json['attachments'] as Array<any>).map(AdminPalletOrderAttachmentsFromJSON)),
        'id': json['id'],
        'items': json['items'],
        'junkItems': !exists(json, 'junkItems') ? undefined : json['junkItems'],
        'name': json['name'],
        'orderDate': json['orderDate'],
        'orderLink': json['orderLink'],
        'price': json['price'],
    };
}

export function AdminPalletOrderToJSON(value?: AdminPalletOrder | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attachments': !value.attachments ? undefined : ((value.attachments as Array<any>).map(AdminPalletOrderAttachmentsToJSON)),
        'id': value.id,
        'items': value.items,
        'junkItems': value.junkItems,
        'name': value.name,
        'orderDate': value.orderDate,
        'orderLink': value.orderLink,
        'price': value.price,
    };
}

